export default __webpack_public_path__ + "static/PressRelease_MilanLaserHairRemoval-MilitaryMakeoverwithMontel-a4e3e989c876aea83f28726caedc12aa.pdf";